
// AOS.init({
//     once: true,
//     throttleDelay: 99,
// });

AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 400, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  });

// Fixed Header JS
document.addEventListener('scroll', function () {
    const header = document.querySelector('.header'); // `.header` element ko select karte hain
    const scrollPosition = window.scrollY; // Current scroll position nikalte hain


    if (scrollPosition > 0) {
        header.classList.add('header-fixed'); // Scroll hone par class add karega
    } else {
        header.classList.remove('header-fixed'); // Scroll top hone par class remove karega
    }
});





// about homepage read more
document.addEventListener('DOMContentLoaded', function () {
    const readMoreBtn = document.querySelector('.read-more-btn');
    const aboutParagraph = document.querySelector('.about-para');

    if (readMoreBtn && aboutParagraph) {
      readMoreBtn.addEventListener('click', function () {
        // Toggle the 'expanded' class
        aboutParagraph.classList.toggle('expanded');
        console.log('Class List:', aboutParagraph.classList); // Debugging

        // Update button text
        if (aboutParagraph.classList.contains('expanded')) {
          readMoreBtn.textContent = 'Read Less';
        } else {
          readMoreBtn.textContent = 'Read More';
        }
      });
    } else {
    //   console.error('Required elements not found.');
    }
  });

//footer content collection
document.addEventListener('DOMContentLoaded', function () {
  // Get the table HTML from the metafield (this is already HTML)
  const myFooterTable = `{{ collection_footer.table }}`;

  // Find the element with the class 'new__footer__table'
  const footerTableContainer = document.querySelector('.new__footer__table');

  // Insert the table HTML into the container
  if (footerTableContainer && myFooterTable) {
    footerTableContainer.innerHTML = myFooterTable;
  }
});

// footer content product

document.addEventListener('DOMContentLoaded', function () {
  // Get the table HTML from the metafield (this is already HTML)
  const myFooterTable = `{{ product_footer.table }}`;

  // Find the element with the class 'new__footer__table'
  const footerTableContainer = document.querySelector('.new__footer__table');

  // Insert the table HTML into the container
  if (footerTableContainer && myFooterTable) {
    footerTableContainer.innerHTML = myFooterTable;
  }
});


